<template>
  <div>
    <general-table
      :api-url="apiUrl"
      :delete-content="false"
      :block-content="false"
      :edit-content="false"
      :view-content="false"
      :columns="columns"
      :type="type"
      :top-header="topHeader"
    >
      <template #cell(status)="data">
        <div style="text-align: center;">
          <b-badge
            pill
            :variant="stutusColor(data.item.status)"
          >
            {{ data.item.status }}
          </b-badge>
        </div>
      </template>
      <template #cell(valid)="data">
        <div style="text-align: center;">
          {{ getTrueORFalse(data.item.valid) }}
        </div>
      </template>
      <template #cell(accepted_by_responsible)="data">
        <div style="text-align: center;">
          {{ getTrueORFalse(data.item.accepted_by_responsible) }}
        </div>
      </template>
      <template #cell(satisfactory)="data">
        <div style="text-align: center;">
          {{ getTrueORFalse(data.item.satisfactory) }}
        </div>
      </template>
      <template #cell(action)="data">
        <b-badge
          v-if="data.item.status === 'pending'"
          pill
          :variant="hoveredId === data.item.id ? 'dark' : 'info'"
          class="cursor-pointer"
          @mouseenter="hoveredId = data.item.id"
          @mouseleave="hoveredId = null"
          @click="$router.push({ name: 'admin-initial', params: { id: data.item.id} })"
        > Admin initial</b-badge>
        <b-badge
          v-if="data.item.status === 'awaiting verification'"
          pill
          class="cursor-pointer"
          :variant="hoveredId === data.item.id ? 'dark' : 'info'"
          @click="awaitingVerification(data.item.id)"
          @mouseenter="hoveredId = data.item.id"
          @mouseleave="hoveredId = null"
        >
          Admin Verify</b-badge>

      </template>
    </general-table>
  </div>
</template>

<script>
import axios from 'axios'
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable },
  data() {
    return {
      viewContent: true,
      hoveredId: null,
      type: 'page',
      filter: {},
      columns: [
        { key: 'complaint_id', label: '' },
        { key: 'status', label: '' },
        { key: 'client_name', label: 'client name' },
        { key: 'email', label: 'email' },
        { key: 'client_number', label: 'client number' },
        { key: 'description', label: '' },
        { key: 'request_id', label: '' },
        { key: 'type_of_service', label: '' },
        { key: 'type_of_complaint', label: '' },
        { key: 'assigned_employee.name', label: 'name' },
        { key: 'assigned_employee.email', label: 'email' },
        { key: 'assigned_employee.office.name', label: 'office' },
        { key: 'remarks', label: '' },
        { key: 'valid', label: '' },
        { key: 'category', label: '' },
        { key: 'responsible_employee.name', label: 'name' },
        { key: 'responsible_employee.email', label: 'email' },
        { key: 'responsible_employee.office.name', label: 'office' },
        { key: 'accepted_by_responsible', label: '' },
        { key: 'root_cause', label: '' },
        { key: 'corrective_action', label: '' },
        { key: 'satisfactory', label: '' },
        { key: 'next_follow_up', label: '' },
        { key: 'action', label: '' },
      ],
      topHeader: [
        { lable: 'complaint id', colspan: 1 },
        { lable: 'status', colspan: 1 },
        { lable: 'Client  Information', colspan: 3 },
        { lable: 'description', colspan: 1 },
        { lable: 'request id', colspan: 1 },
        { lable: 'type of service', colspan: 1 },
        { lable: 'type of complaint', colspan: 1 },
        { lable: 'assigned employee', colspan: 3 },
        { lable: 'remarks', colspan: 1 },
        { lable: 'valid', colspan: 1 },
        { lable: 'category', colspan: 1 },
        { lable: 'responsible employee', colspan: 3 },
        { lable: 'accepted by responsible', colspan: 1 },
        { lable: 'root cause', colspan: 1 },
        { lable: 'corrective action', colspan: 1 },
        { lable: 'satisfactory', colspan: 1 },
        { lable: 'next follow up', colspan: 1 },
        { lable: 'Actions', colspan: 1 },
      ],
    }
  },

  computed: {

    apiUrl() {
      let base = 'complaints?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      return base.slice(0, -1)
    },
  },
  mounted() {
  },

  methods: {
    stutusColor(data) {
      switch (data) {
        case 'closed':
          return 'dark'
        case 'pending':
          return 'success'
        case 'investigating by responsible employee':
          return 'info'
        case 'rejected':
          return 'danger'
        case 'investigating by assigned employee':
          return 'info'
        case 'awaiting verification':
          return 'success'
        default:
          return 'primary'
      }
    },
    filterTypes(type) {
      const filteredType = this.status.filter(item => item.text !== type)
      this.types = filteredType
    },
    getTrueORFalse(data) {
      return data ? '✅' : '❌'
    },
    awaitingVerification(id) {
      this.$swal({
        title: 'Admin Verify',
        width: 600,
        html: `
    <div style="display: flex; flex-direction: column; gap: 15px; align-items: start;">
      <label for="nextFollowUp">Next Follow Up Date:</label>
      <input type="date" id="nextFollowUp" class="swal2-input" style="width: 100%;"/>

      <div style="display: flex; align-items: center;">
        <input type="checkbox" id="satisfactory" />
        <label for="satisfactory" style="margin-left: 5px; font-size: 18px;">Satisfactory</label>
      </div>
    </div>
  `,
        showCancelButton: true,
        confirmButtonText: 'Verify',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        preConfirm: () => {
          const selectednextFollowUp = document.getElementById('nextFollowUp').value
          const selectedSatisfactory = document.getElementById('satisfactory').checked
          if (!selectednextFollowUp || !selectedSatisfactory) {
            this.$swal.showValidationMessage('next follow up and satisfactory is required!')
            return false
          }
          return { selectednextFollowUp, selectedSatisfactory }
        },
      }).then(result => {
        if (result.isConfirmed) {
          this.$swal.fire({
            title: 'Verifying...',
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading()
            },
          })

          const payload = {
            satisfactory: result.value.selectedSatisfactory,
            next_follow_up: result.value.selectednextFollowUp,
          }

          axios.post(`/complaints/${id}/verify`, payload)
            .then(() => {
              this.$swal.close()
              this.$toast.success('complaint verified successfully!')
              window.location.reload()
            })
            .catch(() => {
              this.$swal.close()
              this.$toast.error('Failed to verified.')
            })
        }
      })
    },
  },
}
</script>

<style></style>
